module.exports = __webpack_public_path__ + "img/IRISi.5747e8ff.png";